export default "__VITE_ASSET__38fa7ca4__"